import React, { useEffect, useState } from "react";
import { toast } from "sonner";
import { Heart, AlarmClock } from "lucide-react";
import { api, errorText } from "@/lib/api";
import { usePrefs } from "@/contexts/PrefsContext";
import { Switch } from "@/components/ui-kit";

type Prefs = { fav_events: boolean; reminders: boolean };

const Row = ({ k, icon: Icon, p, onChange }: { k: keyof Prefs; icon: any; p: Prefs; onChange: (k: keyof Prefs, v: boolean) => void }) => {
  const { t } = usePrefs();
  const id = k === "fav_events" ? "fav-events" : "reminders";
  return (
    <div data-testid={`${id}-row`} className="flex items-center gap-3">
      <span className="grid place-items-center h-10 w-10 rounded-2xl bg-primary/10 shrink-0"><Icon className="h-5 w-5 text-primary" /></span>
      <div className="flex-1 min-w-0">
        <p className="font-bold">{t(`np.${k}.title`)}</p>
        <p className="text-sm text-muted-foreground">{t(`np.${k}.sub`)}</p>
      </div>
      <Switch data-testid={`${id}-switch`} checked={p[k]} onCheckedChange={(v: boolean) => onChange(k, v)} />
    </div>
  );
};

export const FavEventsToggle = () => {
  const { t } = usePrefs();
  const [p, setP] = useState<Prefs | null>(null);
  useEffect(() => { api.get("/me/notify-prefs").then((r) => setP(r.data)).catch(() => setP(null)); }, []);
  if (!p) return null;
  const change = async (k: keyof Prefs, v: boolean) => {
    const prev = p;
    setP({ ...p, [k]: v });
    try { setP((await api.put("/me/notify-prefs", { [k]: v })).data); toast.success(t(v ? "np.on" : "np.off")); } catch (e) { setP(prev); toast.error(errorText(e, t)); }
  };
  return (
    <section data-testid="fav-events-card" className="rounded-3xl border bg-card p-5 space-y-4">
      <h2 className="font-display text-lg font-bold">{t("np.title")}</h2>
      <Row k="reminders" icon={AlarmClock} p={p} onChange={change} />
      <Row k="fav_events" icon={Heart} p={p} onChange={change} />
    </section>
  );
};
